import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = [ "checkbox", "drawer", "drawerContentWrapper" ]

  connect() {
    this.loadingContent = this.drawerTarget.innerHTML
    this.sizes = {
      "xs": ["w-11/12", "md:w-80"],
      "sm": ["w-11/12", "md:w-8/12", "lg:w-1/2", "xl:w-1/3"],
      "md": ["w-11/12", "lg:w-2/3", "xl:w-1/2"],
      "lg": ["w-11/12", "xl:w-2/3"]
    }
  }

  open(event) {
    const size = event.params.size ?? "sm"
    this.drawerTarget.classList.add(...this.sizes[size])
    this.drawerTarget.innerHTML = this.loadingContent
    this.checkboxTarget.checked = true

    if (event.params.hasOwnProperty("contentBlockId")) {
      const contentBlock = document.getElementById(event.params.contentBlockId)
      if (contentBlock) {
        this.drawerContentWrapperTarget.replaceChildren(contentBlock.cloneNode(true))
      }
    }
  }

  close(event) {
    this.checkboxTarget.checked = false
  }
}
